/**
 * Served from `public/assets/` (root URL `/assets/...`).
 * Use `.display` variants (small intrinsic size) so Angular NG0913 does not warn when CSS scales them down.
 */
export const BRAND_ICON_SRC = '/assets/WORKNEST-ICON.display.png';
export const BRAND_LOGO_SRC = '/assets/WorkNestLogo.display.png';
